<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_THEME_PALETTES"
    title="Clone Theme Palette"
    :breadcrumbs="breadcrumbs"
    page-name="Clone Theme Palette"
  >
    <iColumn>
      <ThemePaletteConfiguration
        v-model="innerPalette"
        @has-errors="formHasErrors = $event"
      />

      <iSpace :height="10" />
      <iText v-if="formHasErrors" variant="error">
        Please correct the errors above before saving.
      </iText>
      <iRow>
        <iColumn width="hug">
          <iButton
            :is-loading="isLoadingPostPalette"
            loading-spinner-position="inside"
            :disabled="formHasErrors"
            variant="primary"
            @click="cloneThemePalette(innerPalette)"
          >
            Clone
          </iButton>
        </iColumn>
        <iColumn width="hug">
          <iLink :href="`/publication/org/${orgId}/theme-palettes`">
            <iButton variant="secondary">
              Cancel
            </iButton>
          </iLink>
        </iColumn>
      </iRow>
    </iColumn>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import ThemePaletteConfiguration from "@/components/ThemePaletteConfiguration";
import {
  PAGE_THEME_PALETTES,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useGeneralStore } from "%/stores/general-store";
import { useThemesStore } from "@/stores/themes-store";
import { mapActions, mapState } from "pinia";

export default {
  name: "ThemePalettesClone",
  components: { ThemePaletteConfiguration, PageWrapper },
  props: {
    palette: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      SECTION_PUBLICATIONS,
      PAGE_THEME_PALETTES,
      innerPalette: this.palette,
      formHasErrors: false,
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["orgId"]),
    ...mapState(useThemesStore, ["isLoadingPostPalette"]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/org/${this.orgId}/theme-palettes`,
          label: "Theme Palettes",
        },
      ];
    },
  },
  methods: {
    ...mapActions(useThemesStore, ["cloneThemePalette"]),
  },
};
</script>

<style scoped lang="scss"></style>
